import { createAction, props } from '@ngrx/store';
import { DataSource } from '@sharedModule/models/data-source.model';
import { RoleListInterface } from '../types/role-list';
import { RoleListFilter } from '../types/role-list-filter';

export const fetchRoleList = createAction(
  '[Role List] Role List Fetch',
  props<{ filter?: RoleListFilter }>()
);

export const updateRoleListFilter = createAction(
  '[Role Filter] Role List update filter',
  props<{ filter?: RoleListFilter }>()
);

export const loadedRoleList = createAction(
  '[Role List] Role List Loaded',
  props<{ dataSource: DataSource<RoleListInterface[]> }>()
);

export const failedRoleList = createAction('[Role List] Role List Failed');

export const deleteRole = createAction(
  '[Role List] Delete Role',
  props<{ role_id: string }>()
);

export const resetRoleList = createAction('[Role List] Reset Role List');
